if (!customElements.get('natunora-listicle-gallery')) {
  customElements.define('natunora-listicle-gallery', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.n-listicle-gallery__viewport');
      this.previous = this.querySelector('.n-listicle-gallery__prev');
      this.next = this.querySelector('.n-listicle-gallery__next');
      this.count = this.querySelectorAll('.n-listicle-gallery__slide').length;
      if (!this.viewport || !this.count) return;
      this.index = 0;
      this.destination = null;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.hidden = this.next.hidden = this.count < 2;
      this.previous.addEventListener('click', () => this.go(this.index - 1), options);
      this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.viewport.addEventListener('keydown', (event) => {
        const targets = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.count - 1 };
        if (!(event.key in targets)) return;
        event.preventDefault();
        this.go(targets[event.key]);
      }, options);
      for (const event of ['pointerdown', 'wheel']) {
        this.viewport.addEventListener(event, () => { this.destination = null; }, { ...options, passive: true });
      }
      this.viewport.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const position = this.viewport.scrollLeft / this.viewport.clientWidth;
          if (this.destination !== null && Math.abs(position - this.destination) > .01) return;
          this.destination = null;
          this.index = Math.max(0, Math.min(this.count - 1, Math.round(position)));
          this.update();
        });
      }, { ...options, passive: true });
      this.width = this.viewport.clientWidth;
      this.resize = new ResizeObserver(() => {
        const width = this.viewport.clientWidth;
        if (width && width !== this.width) {
          this.width = width;
          this.destination = this.index;
      this.viewport.scrollTo({ left: this.index * width, behavior: 'instant' });
        }
      });
      this.resize.observe(this.viewport);
      this.update();
    }
    go(index) {
      this.index = Math.max(0, Math.min(this.count - 1, index));
      this.destination = this.index;
      this.viewport.scrollTo({ left: this.index * this.viewport.clientWidth,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.update();
    }
    update() {
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.count - 1;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
